import { render } from "./IconCrossOutlined.vue?vue&type=template&id=138115dc"
import script from "./IconCrossOutlined.vue?vue&type=script&lang=js"
export * from "./IconCrossOutlined.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconCrossOutlined.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "138115dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('138115dc', __exports__)) {
    api.reload('138115dc', __exports__)
  }
  
  module.hot.accept("./IconCrossOutlined.vue?vue&type=template&id=138115dc", () => {
    api.rerender('138115dc', render)
  })

}


export default __exports__